import { render } from "./TicketModal.vue?vue&type=template&id=ec2598ce&scoped=true"
import script from "./TicketModal.vue?vue&type=script&lang=js"
export * from "./TicketModal.vue?vue&type=script&lang=js"

import "./TicketModal.vue?vue&type=style&index=0&id=ec2598ce&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ec2598ce"]])

export default __exports__